import {EventEmitter, Injectable, Output} from '@angular/core';
import {Report} from "../../../model/report";

@Injectable()
export class MainMenuService {
  @Output() deactivateTopMenuActivePosition = new EventEmitter<boolean>();
  @Output() markReportAsShown = new EventEmitter<Array<Report>>();

  constructor() { }

  getNewReportsNumber() {

  }
}